import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/Dapta-Brandmark-RGB.png'


const _hoisted_1 = { id: "app-header" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  class: "inactive",
  style: {"float":"right"}
}
const _hoisted_9 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","text-align":"left","padding-left":"20px"} }
const _hoisted_10 = { style: {"list-style":"none","text-align":"left","padding":"0","margin":"0"} }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "option-description" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "option-buttons" }
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "option" }
const _hoisted_21 = { class: "option-description" }
const _hoisted_22 = { class: "option" }
const _hoisted_23 = {
  for: "fileInput",
  class: "custom-file-input"
}
const _hoisted_24 = { class: "option-description" }
const _hoisted_25 = {
  key: 2,
  id: "vue-flow"
}
const _hoisted_26 = { class: "loading" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo rotate",
  width: "70",
  height: "70"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

import { onMounted, ref, reactive, toRefs, inject, watch } from "vue";
import { useAuth0 } from '@auth0/auth0-vue';
import Shared from './shared.vue'
import BaseDialog from "./BaseDialog.vue";
import SmallDialog from "./SmallDialog.vue";
import userResourceQuotas from "./UserResourceQuotas.json"
import tutorials from "./Tutorials.json"
import { useRouter } from 'vue-router'

import CustomNode from "./CustomEditableNode.vue";
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'Interface',
  props: {
  tutorial: String,
},
  setup(__props) {

const props = __props;


const router = useRouter();
const { user, logout } = useAuth0();
const loaded = ref(false);
const workflow = ref();
let fileInput = ref();
let flowView = ref();
const k8sAdminAPIEndPoint = inject('back_end_admin_API_end_point');
const userJWTToken = inject('userJWTToken');
const isNamespace = ref(false)
const logFound = ref(false)
const viewlog = ref(false)
const flowIslocked = ref(true)
const moreOptions = ref(false)
const hideOnBoardingMsg = ref(false)
const loading = ref(false)
const runName = ref()
const viewRunStore = ref(false)
const allRuns = ref()
const viewGetRunName = ref(false)

// add new codes for change language
const { locale, t } = useI18n();
const toggleLanguage = () => {
  locale.value = locale.value === 'en' ? 'zh' : 'en';
}

const manualSaveToStore = async () => {
  flowIslocked.value = true;
  loaded.value && await saveRunToStore();
  flowIslocked.value = false;
}

const openItem = async () => { 
  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")
  viewRunStore.value = true;
}

const runNameIsUnique = (name) => { 
  if (allRuns.value.filter(e => e.name === name).length) { 
    return false
  }
  return true
}

const onSetRunName = (name, args) => { 
  if (runNameIsUnique(name)) {
    runName.value = name;
    viewGetRunName.value = false;
    loading.value = false;
    loaded.value = true;
  } else { 
    alert("\u274C This name is already associated with a stored run.\nPlease choose another name.")
  }
}
const onLoadTutorial = async (name, args) => { 
  if (runNameIsUnique(name)) {
    runName.value = name;
    viewGetRunName.value = false;
    await renameRunFolder("_scr_" + tutorials[props.tutorial].name, runName.value)
    router.push('/interface')
    const flow = await Shared.methods.call_be_api_download(k8sAdminAPIEndPoint, userJWTToken.value, runName.value)
    flow.run_parameters.name = runName.value
    workflow.value = flow 
    loading.value = false;
    loaded.value = true;
  } else { 
    alert("\u274C This name is already associated with a stored run.\nPlease choose another name.")
  }  
}
const cancelGetRunName = () => { 
  console.log("Cancel GetRunName.")
  viewGetRunName.value = false;
  viewRunStore.value = true;
  loading.value = false;
}
const smallDialog = ref({
  callback: onSetRunName,
  callbackArgs: {},
  heading: "Create Run",
  onCancel: cancelGetRunName
})

const onFileSelected = async (ev) => {
  const file = ev.target.files[0];
  const reader = new FileReader();

  reader.addEventListener("load", (e) => {
    try {
      if (typeof reader.result !== "string")
        throw "FileReader did not return string.";
      workflow.value = JSON.parse(reader.result);
      if (workflow.value.run_parameters?.name) {
        runName.value = workflow.value.run_parameters?.name
      } else { 
        runName.value = ""
      }
      console.log("loaded from file:", workflow.value);
    } catch (ex) {
      console.log("ex when trying to parse json =" + ex);
    }
  });
  if (file) reader.readAsText(file);

  console.log(`Input file ${file.path} read-in successfully.`);
};

const saveToFile = async (data : string, filename : string) => {
  const blob = new Blob([data], {type : 'application/json'});
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob)
  link.download = filename;
  link.dataset.downloadurl = ['text/json', link.download, link.href].join(':');
  link.click();
  window.URL.revokeObjectURL(link.href);
};

const toggleFlowLock = (data) => { 
  flowIslocked.value = data
}

const downloadItem = async () => {
  await flowView.value.logToObject(true);
};



const createNewObject = async (objCreateCallback, ev) => { 
  if (allRuns.value.length >= Number(userResourceQuotas.runs)) {
    alert("\u26A0 Warning: You have reached the maximum number of runs.\nDelete a saved run before creating a new one.")
    if (fileInput.value?.type) { 
      // change type to reset event
      fileInput.value.type = "text";
      fileInput.value.type = "file";
    }
    return
  }
  loading.value = true; 
  viewRunStore.value = false;
  if (await terminateOnUserConfirm()) {
    loading.value = false; 
    return;
  }
  loaded.value = false; 
  smallDialog.value.callback = onSetRunName
  smallDialog.value.heading = t('message.Create_Run') 
  smallDialog.value.callbackArgs = {}
  await objCreateCallback(ev)
  viewGetRunName.value = true;
}

const callResetObject = async (ev) => {
  runName.value = ""
  workflow.value = JSON.parse(
    '{"components": [], "connections": [], "workflow": {},  "run_parameters": {}}'
  );    
  console.log("loaded from file:", workflow.value);
};

const callGetTutorial = async () => { 
  console.log("load tutorial: ", props.tutorial)
  runName.value = tutorials[props.tutorial].name
  // load dummy workflow
  workflow.value = JSON.parse(
    '{"components": [], "connections": [], "workflow": {},  "run_parameters": {}}'
  );
  smallDialog.value.callback = onLoadTutorial
  smallDialog.value.heading = `Create Run from Tutorial #${props.tutorial}`
  smallDialog.value.callbackArgs = {}    
}

const viewRunLog = () => { viewlog.value = true; }

const getMoreOptions = () => { moreOptions.value = true; }

const logoutUser = () => {  
  logout({ returnTo: "https://www.dapta.com/wp-login.php?action=logout" });
  }

const setUpTutorial = async () => { 
  if (!(props.tutorial in tutorials)) { 
    alert("The requested tutorial ID doesn't exist.")
    return false
  }
  await createNewObject(callGetTutorial, null)
  if (workflow.value) {
    return true
    }
  return false
} 

const callLoadActiveObject = async () => { 
  // read input json from server and load vueflow
  if (props.tutorial && await setUpTutorial()) {
    return;
    }
  if (isNamespace.value) {
    workflow.value = await Shared.methods.call_be_api_download(k8sAdminAPIEndPoint, userJWTToken.value, runName.value)
  } else if (localStorage.currentRun) {
    workflow.value = JSON.parse(localStorage.currentRun)
    runName.value = workflow.value["run_parameters"]["name"]
  } else { 
    await openItem()
    return;
  }
  console.log("loaded from file:", workflow.value);
  loaded.value = true;
}

const callLoadRunFromStore = async (name, beApiTerminate = true) => { 
  loading.value = true;
  viewRunStore.value = false;
  if (runName.value !== name) {
    if (await terminateOnUserConfirm(true, beApiTerminate)) {
      loading.value = false; 
      viewRunStore.value = true;
      return;
    }
    runName.value = name
  }
  workflow.value = await Shared.methods.call_be_api_download(k8sAdminAPIEndPoint, userJWTToken.value, name)
  workflow.value.run_parameters.name = runName.value
  console.log("loaded from file:", workflow.value);
  loading.value = false;
  loaded.value = true;
}

const onTerminateRun = async () => { 
  // delete the user namespace without deleting files
  loading.value = true;
  if (await terminateOnUserConfirm()) {
    loading.value = false; 
    return;
  }
  loaded.value = false
  runName.value = ""
  workflow.value = null
  loading.value = false;
  await callLoadActiveObject()
}

const deleteRunFromStore = async (name) => { 
  loading.value = true;
  if (name === runName.value) { 
    viewRunStore.value = false;
    if (await terminateOnUserConfirm(false)) {
      loading.value = false; 
      viewRunStore.value = true;
      return;
    }
    runName.value = ""
    loaded.value = false;
  }
  await Shared.methods.call_be_api_delete_files(k8sAdminAPIEndPoint, userJWTToken.value, null, null, null, name);
  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")
  viewRunStore.value = true;
  console.log("deleted run: ", name);
  loading.value = false;
}

const terminateOnUserConfirm = async (autosave = true, beApiTerminate = true) => { 
  if (beApiTerminate) {
    isNamespace.value = await Shared.methods.call_get_Namespace_exists(k8sAdminAPIEndPoint, userJWTToken.value, "any")
  }
  if ( beApiTerminate && isNamespace.value == true) {
    if (confirm("Warning: \nThe existing run cluster will be stopped and run logs will be deleted. \n\nDo you want to continue?") == true) {
      flowIslocked.value = true;
      logFound.value = false;
      await Shared.methods.call_be_api_terminate(k8sAdminAPIEndPoint, userJWTToken.value)
      if (loaded.value && autosave) {
        await saveRunToStore()
        const canvasBlob = await Shared.methods.getScreenshot()
        await Shared.methods.uploadScreenshot(k8sAdminAPIEndPoint, userJWTToken.value, runName.value, canvasBlob)
      }
      if (localStorage.currentRun) {
        localStorage.currentRun = ""
      };
      isNamespace.value = false;
      flowIslocked.value = false;
      return false;
    } else {
      console.log("cluster reset cancelled by user -> exiting current function call.")
      return true;
    }
  } else if (loaded.value) { 
    flowIslocked.value = true;  
    if (autosave) {
      await saveRunToStore()
      const canvasBlob = await Shared.methods.getScreenshot()
      await Shared.methods.uploadScreenshot(k8sAdminAPIEndPoint, userJWTToken.value, runName.value, canvasBlob)
    }
    if (localStorage.currentRun) {
      localStorage.currentRun = ""
    };
    flowIslocked.value = false;
    return false;
  }
}

const saveRunToStore = async () => { 
  await flowView.value.logToObject(false);
  await flowView.value.call_be_api_upload()
  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")
}

const renameRunFolder = async (source, target) => { 

  loading.value = true;
  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")

  let method = "";
  if (source === target) {
    method = "duplicate";
    target = target + "-copy"
  } else if (source.startsWith("_scr_")) { 
    method = "tutorial";
    source = source.substr(5)
  }

  if (allRuns.value.filter(e => e.name === target).length) { 
    alert(`\u274C A run with the name ${target} already exists. Delete or rename that run first.`)
    loading.value = false;
    return
  }

  const data = new FormData()
  data.append('source', source);
  data.append('target', target);
  if (method) { 
    data.append('method', method);
  }
  const resp = await fetch(k8sAdminAPIEndPoint + "/renamerunfolder", {
    method: "POST",
    headers: { "Authorization": `Bearer ${userJWTToken.value}`},
    body: data
  }).then(Shared.methods.handleErrors)
    .then(response => { return response.text() })
  console.log(resp)

  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")
  loading.value = false;
}

const onRunReName = async (name, args) => { 
  if (runNameIsUnique(name)) {
    viewGetRunName.value = false;
    if (args["source"] === runName.value) { 
      console.warn("renaming loaded run")
      if (await terminateOnUserConfirm()) {
        loading.value = false; 
        return;
      }
      runName.value = ""
      loaded.value = false
    }  
    await renameRunFolder(args["source"], name)
    viewRunStore.value = true;
    loading.value = false;
  } else { 
    alert("\u274C This name is already associated with a stored run.\nPlease choose another name.")
  }
}

const getNameThenRename = (source) => { 
  loading.value = true;
  smallDialog.value.callback = onRunReName
  smallDialog.value.callbackArgs = { "source": source }
  smallDialog.value.heading = "Rename Run"
  viewGetRunName.value = true;
  viewRunStore.value = false;
}

const openInNewTab = (url) => {
      window.open(url, '_blank', 'noreferrer');
    }

const localStorageAvailable = () => {
    if (typeof(Storage) !== "undefined") {
        return true;
    }
    else {
        return false;
    }
}

const setOnBoardingMsg = () => {
  if (localStorageAvailable()) {
        if (localStorage.hideOnBoardingMsg && localStorage.hideOnBoardingMsg === "true") {
            hideOnBoardingMsg.value = true
        }
    };
}
setOnBoardingMsg()

const cacheToLocalstorage = async (data: string) => { 
  if (localStorageAvailable()) {
        console.log("caching current run")
        localStorage.currentRun = String(data);
    };  
}


const createChat = () => { 
  let smartsuppScript = document.createElement('script')
  smartsuppScript.src = process.env.BASE_URL + "smartsupp.js"
  document.head.appendChild(smartsuppScript)
  let scriptIsReady = false;
  let checkInterval = setInterval(function () {
      if (window.smartsupp) {
        scriptIsReady = true;
        clearInterval(checkInterval);
        console.log("sending data to smartsupp")
        window.smartsupp('name', user.value.nickname);
        window.smartsupp('email', user.value.email);
      }
      return scriptIsReady;
    }, 500);
}

const toggleOnBoardingMsg = (val) => { 
  console.log("set hideOnBoardingMsg message to ", val)
  if (localStorageAvailable()) {
    localStorage.hideOnBoardingMsg = String(val);
  }
}

watch(
  () => [props.tutorial],
  (newval, oldval) => {
   console.log("props.tutorial update: ", newval, oldval)
  }
);

onMounted(async () => {
  [isNamespace.value, runName.value] = await Shared.methods.call_get_Namespace_exists(k8sAdminAPIEndPoint, userJWTToken.value, "any", true)
  allRuns.value = await Shared.methods.call_be_api_getstoreitems(k8sAdminAPIEndPoint, userJWTToken.value, "runs")
  await callLoadActiveObject()
  flowIslocked.value = false;
  createChat()
  console.warn("mounted Interface");
})


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "reset",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewObject(callResetObject, null))),
        disabled: flowIslocked.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "plus-circle",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.New')), 1)
      ], 8, _hoisted_2),
      _createElementVNode("button", {
        id: "openItem",
        onClick: openItem,
        disabled: flowIslocked.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "folder-open",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.Open')), 1)
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        id: "saveItem",
        onClick: manualSaveToStore,
        disabled: !loaded.value || flowIslocked.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "save",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.Save')), 1)
      ], 8, _hoisted_4),
      _createElementVNode("button", {
        id: "downloadItem",
        onClick: downloadItem,
        disabled: !loaded.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "file-download",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.Download')), 1)
      ], 8, _hoisted_5),
      _createElementVNode("button", {
        id: "viewRunLog",
        onClick: viewRunLog,
        disabled: !logFound.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "eye",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.View_Log')), 1)
      ], 8, _hoisted_6),
      _createElementVNode("button", {
        id: "moreOptions",
        onClick: getMoreOptions,
        disabled: !loaded.value
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "ellipsis",
          size: "lg"
        })
      ], 8, _hoisted_7),
      _createElementVNode("button", {
        onClick: logoutUser,
        style: {"float":"right"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "sign-out-alt",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.Log_out')), 1)
      ]),
      _createElementVNode("button", {
        onClick: toggleLanguage,
        style: {"float":"right"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "language",
          size: "lg"
        }),
        _createTextVNode(" En/中 ")
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openInNewTab('https://daptadocs.com/index.html'))),
        style: {"float":"right"}
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          size: "lg"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.Help')), 1)
      ]),
      _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(user).nickname), 1)
    ]),
    (viewRunStore.value)
      ? (_openBlock(), _createBlock(BaseDialog, {
          key: "viewRunStore",
          onClose: _cache[4] || (_cache[4] = ($event: any) => {viewRunStore.value = false;}),
          visibility: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.Saved_Runs')), 1),
              _createElementVNode("button", {
                id: "language",
                onClick: toggleLanguage,
                style: {"float":"right","background-color":"black","color":"white"}
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "language",
                  size: "lg"
                }),
                _createTextVNode(" En / 中 ")
              ])
            ]),
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allRuns.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.name,
                  class: "option"
                }, [
                  _createElementVNode("img", {
                    src: item.thumbnail,
                    alt: "workspace view",
                    class: "option-thumbnail"
                  }, null, 8, _hoisted_11),
                  _createElementVNode("p", _hoisted_12, [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                    _hoisted_13,
                    _createElementVNode("em", null, _toDisplayString(_ctx.$t('message.Last_saved')) + " " + _toDisplayString(item.mtime), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "basedialog",
                      onClick: async() => await callLoadRunFromStore(item.name),
                      disabled: runName.value === item.name
                    }, _toDisplayString(_ctx.$t('message.Load')), 9, _hoisted_15),
                    _createElementVNode("button", {
                      class: "basedialog",
                      onClick: async () => await renameRunFolder(item.name, item.name)
                    }, _toDisplayString(_ctx.$t('message.Duplicate')), 9, _hoisted_16),
                    _createElementVNode("button", {
                      class: "basedialog",
                      onClick: ($event: any) => (getNameThenRename(item.name))
                    }, _toDisplayString(_ctx.$t('message.Rename')), 9, _hoisted_17),
                    _createElementVNode("button", {
                      class: "basedialog",
                      onClick: async() => await deleteRunFromStore(item.name)
                    }, _toDisplayString(_ctx.$t('message.Delete')), 9, _hoisted_18)
                  ])
                ]))
              }), 128)),
              _hoisted_19,
              _createElementVNode("li", _hoisted_20, [
                _createElementVNode("button", {
                  class: "basedialog",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (createNewObject(callResetObject, null)))
                }, _toDisplayString(_ctx.$t('message.New')), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('message.Create_a_new_Run')), 1)
              ]),
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('message.Import')), 1),
                _createElementVNode("input", {
                  id: "fileInput",
                  type: "file",
                  onChange: _cache[3] || (_cache[3] = (ev) => {createNewObject(onFileSelected, ev)}),
                  ref_key: "fileInput",
                  ref: fileInput
                }, null, 544),
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('message.Import_a_run_from_file')), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (viewGetRunName.value)
      ? (_openBlock(), _createBlock(SmallDialog, {
          key: "viewGetRunName",
          callback: smallDialog.value.callback,
          "callback-args": smallDialog.value.callbackArgs,
          heading: smallDialog.value.heading,
          "on-cancel": smallDialog.value.onCancel,
          "run-name": runName.value,
          visibility: ""
        }, null, 8, ["callback", "callback-args", "heading", "on-cancel", "run-name"]))
      : _createCommentVNode("", true),
    (loaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(CustomNode, _mergeProps({
            ref_key: "flowView",
            ref: flowView
          }, workflow.value, {
            isnamespace: isNamespace.value,
            viewlog: viewlog.value,
            "more-options": moreOptions.value,
            "hide-on-boarding-msg": hideOnBoardingMsg.value,
            "run-name": runName.value,
            onLoadFromStore: _cache[5] || (_cache[5] = (name, opt) => callLoadRunFromStore(name,opt.beApiTerminate)),
            onLoading: _cache[6] || (_cache[6] = (val) => {loading.value = val}),
            onFlowSave: saveToFile,
            onFlowCache: cacheToLocalstorage,
            onLogFound: _cache[7] || (_cache[7] = (data) => { logFound.value = data}),
            onCloseLog: _cache[8] || (_cache[8] = ($event: any) => {viewlog.value = false; moreOptions.value = false; viewRunStore.value = false; }),
            onToggleLock: toggleFlowLock,
            onToggleOnBoardingMsg: _cache[9] || (_cache[9] = (val) => { toggleOnBoardingMsg(val) }),
            onResetRun: _cache[10] || (_cache[10] = ($event: any) => {moreOptions.value = false; onTerminateRun()})
          }), null, 16, ["isnamespace", "viewlog", "more-options", "hide-on-boarding-msg", "run-name"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_26, _hoisted_28, 512), [
      [_vShow, !loaded.value || loading.value]
    ])
  ], 64))
}
}

})